module.exports = __webpack_public_path__ + "img/dianzi.26c00ae7.jpg";